import queryString from 'querystring';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { notificationSettingsStateForParamsSelector } from '../../notification-settings/notification-settings-selectors';

import * as Api from '../../api/api';

export const loadNotificationSettings = (params: NotificationSettingQueryRequest) =>
  createGenericDispatcher<Array<NotificationSetting>>({
    name: 'LOAD_NOTIFICATION_SETTINGS',
    loadFunction: () => Api.get(`/notification-settings?${queryString.stringify(params)}`),
    args: { params },
    // I _think_ this should work, but we might need to revisit this idea when we start loading by different parameters
    // Basically, we'll fetch for a given set of query params at least once, even if they overlap in some way with
    // this method
    shouldExecuteSelector: (state: any) =>
      notificationSettingsStateForParamsSelector(state, JSON.stringify(params)),
  });
